<div class="answer-details-wrapper">
  &nbsp;
  <h3>{{ surveyResults?.surveyAnswer[0]?.surveyAnswer }}</h3>
  <div class="mt-20">
    <b class="count-text mt-16" translate>Total Number of Votes for this Option: </b><span>{{ surveyResults?.count }}</span>
  </div>
  <div>
    <p class="survey-heading mt-20" translate>Following people has voted For this option:</p>
    <div class="voting-options mt-15">
      @if (!currentSurvey.additionalAnonymousVoting) {
        <ul>
          @for (voter of surveyResults.votingResult; track voter) {
            <li>
              <h4 class="userName">{{ voter?.userDetails?.fullName }}</h4>
            </li>
          }
        </ul>
      } @else {
        <h4>
          <span class="userName" translate>Anonymous</span>
        </h4>
      }
    </div>
  </div>
</div>
